/** @format */
import '@js/shared-sessions.js';

/**
 * Priority booking button logic
 */
jQuery(function ($) {

    if ($.fn.sharedSession) {
        console.log('Shared session plugin loaded')
        const $priorityBooking = $('#priority-booking')
        if ($priorityBooking.length) {
            $priorityBooking.sharedSession("session", {
                cache: 300,
                debug: true,
                success: function (response, params) {
                    console.log(response)
                    if ('sessions' in response) {
                        const url = new URL(wpApiSettings.root + 'v1/attendable/priority-booking/')
                        const requestOptions = {
                            method: 'GET',
                            headers: {
                                'X-WP-Nonce': wpApiSettings.nonce,
                            }
                        }

                        const eventID = parseInt($priorityBooking.data('eventId'))
                        const modeOfSaleId = response.sessions?.ModeOfSaleId ? response.sessions.ModeOfSaleId : 15
                        url.searchParams.append('eventId', eventID);
                        url.searchParams.append('modeOfSaleId', modeOfSaleId);

                        fetch(url, requestOptions)
                            .then(response => response.json())
                            .then(response => {
                                if (response.data.success && response.data.success === false) {
                                    console.warn("Could not update menu and content")
                                    return;
                                }
                                $priorityBooking.html(response.data.html)
                            })
                            .catch(error => console.log(error));
                    }
                },
                error: function (response, params) {
                }
            });
        }
    }
})
